import React from 'react'
import PropTypes from 'prop-types'

function Complete(props) {
  const { totalAmount, currency, fieldSizes, selectedSize, selectedDate, selectedDuration, selectedInterval } = props
  const selectedFields = fieldSizes[selectedSize]
  const availableFields = selectedFields.filter(field => selectedInterval.fields.includes(field.id))
  const selectedField = availableFields[0]
  const currencyName = currency && currency != 'usd' ? ` (${currency.toUpperCase()})` : ''

  const fieldInfo = () => {
    const fieldName = selectedField.name
    const fieldNumber = `Field #${selectedField.number}`
    const fieldSize = `${selectedSize}v${selectedSize}`
    return [fieldSize, fieldName, fieldNumber].filter(e => e).join(' | ')
  }

  const timeInterval = () => {
    const startTime = moment(selectedInterval.text, 'LT')
    const endTime = startTime.clone().add(selectedDuration, 'hours')
    return `${startTime.format('LT')} - ${endTime.format('LT')}`
  }

  return <div className='complete'>
    <span className='complete__icon'><i className='fa fa-solid fa-check'></i></span>
    <span className='complete__header'>Reservation Request Confirmed</span>
    <div className='complete__desc'>
      <span className='complete__desc__warning'>You have successfully booked:</span>
      <span className='complete__desc__info'>{fieldInfo()}</span>
      <span className='complete__desc__info'>{selectedDate.format('MMMM Do, YYYY')}</span>
      <span className='complete__desc__info'>{timeInterval()}</span>
    </div>
    <span className='complete__price'>{`Total Reservation Cost | $${totalAmount.toFixed(2)}${currencyName}`}</span>
    <button className='btn btn-more' onClick={props.onBookMore}>Reserve Another Field</button>
  </div>
}

Complete.propTypes = {
  fieldSizes: PropTypes.object.isRequired,
  selectedSize: PropTypes.string.isRequired,
  selectedDate: PropTypes.object.isRequired,
  selectedDuration: PropTypes.string.isRequired,
  selectedInterval: PropTypes.object.isRequired,
  totalAmount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  onBookMore: PropTypes.func.isRequired
}

export default Complete
